
    import './styles.scoped.css';
    export default {
  "modal-actions": "awsui_modal-actions_12hyz_w54ch_181",
  "submit-button": "awsui_submit-button_12hyz_w54ch_185",
  "last-updated-caption": "awsui_last-updated-caption_12hyz_w54ch_189"
};
  